import React, { useEffect, useState } from "react";
import "../css/HomePage.css";
import ic_important_notifications from "../img/ic_notification.png";
import ic_offers from "../img/ic_offers.png";
import ic_offer_1 from "../img/ic_offer_1.png";
import EnquiryListTable from "./EnquiryListTable";
import axios from "axios";
import ic_waiting_for_approval from "../img/ic_waiting_for_approval.png";
import ic_order_confirmed from "../img/ic_order_confirmed.png";
import ic_quotation_generated from "../img/ic_quotation_generated.png";
import ic_total_files from "../img/ic_total_files.png";
import ic_no_notification from "../img/ic_no_notification.svg";
import ic_no_offer from "../img/ic_no_offer.svg";
import ic_history from "../img/ic_history.png";

const Homepage = () => {


  const [isCallingHeaderApi, setIsCallingHeaderApi] = useState(false)

  const [orderStatusCount, setOrderStatusCount] = useState([]);

  const [orderStatusCountObject, setOrderStatusCountObject] = useState({
    waiting_for_accept: 0,
    order_confirmed: 0,
    quotation_generated: 0,
    sum: 0,
    ttlamtofpropsl: 0,
    totalsales: 0
  });

  //get company
  let current_company = localStorage.getItem("current_company");
  let currentCompany;
  if (current_company) {
    currentCompany = JSON.parse(current_company);
  }
  let current_company_account_number = localStorage.getItem("current_company_account_number");
  let companyAccountNumberToSend;
  if (current_company_account_number) {
    companyAccountNumberToSend = JSON.parse(current_company_account_number);
  }

  const [importantNotifications, setImportantNotifications] = useState([]);
  const [offers, setOffers] = useState([]);

  useEffect(() => {
    // get important notifcations
    const apiUrlImportantNotification = `${process.env.REACT_APP_BASE_URL}/feeds/messages/${currentCompany.company_code}`;
    axios
      .get(apiUrlImportantNotification)
      .then((res) => {
        if (res.data) {
          console.log("important notifications is", res.data);
          setImportantNotifications(res.data);
        }
      })
      .catch((e) => {
        //console.log("something went wrong");
      });

    // get offers
    const apiUrlOffers = `${process.env.REACT_APP_BASE_URL}/feeds/offers/${currentCompany.company_code}`;
    axios
      .get(apiUrlOffers)
      .then((res) => {
        console.log("offers is  ", res.data);
        setOffers(res.data);
      })
      .catch((e) => {
        //console.log("something went wrong");
      });
  }, []);

  const getHeaderData = () => {

    setIsCallingHeaderApi(true)
    // get company code from local storage , then call API using that code

    let current_company_local = localStorage.getItem("current_company");
    let currentCompany;
    if (current_company_local) {
      currentCompany = JSON.parse(current_company_local);

      console.log("Home page company value is  ", currentCompany);

      // get order status count
      const apiUrlOrderStatusCount = `${process.env.REACT_APP_BASE_URL}/orderstatuscount/${currentCompany.company_code}/${companyAccountNumberToSend.number}`;
      axios
        .get(apiUrlOrderStatusCount)
        .then((res) => {

          setIsCallingHeaderApi(false)

          console.log("order and status count is  ", res.data);
          setOrderStatusCount(res.data);
        })
        .catch((e) => {
          setIsCallingHeaderApi(false)
          //console.log("something went wrong");
        });
    }
  };

  useEffect(() => {
    console.log("Order status count array change useEffect ", orderStatusCount);

    if (orderStatusCount.length > 0) {
      orderStatusCount.map((item) => {
        if (item.status == "Waiting For Accept") {
          setOrderStatusCountObject((prev) => ({
            ...prev,
            waiting_for_accept: item.nos,
          }));
        }
        if (item.status == "Order Confirmed") {
          setOrderStatusCountObject((prev) => ({
            ...prev,
            order_confirmed: item.nos,
          }));
        }

        if (item.status == "Quotation Generated") {
          setOrderStatusCountObject((prev) => ({
            ...prev,
            quotation_generated: item.nos,
          }));
        }

        if (item.status == "SUM") {
          setOrderStatusCountObject((prev) => ({
            ...prev,
            sum: item.nos,
          }));
        }

        if (item.status == "ttlamtofpropsl") {
          setOrderStatusCountObject((prev) => ({
            ...prev,
            ttlamtofpropsl: item.nos,
          }));
        }

        if (item.status == "totalsales") {
          setOrderStatusCountObject((prev) => ({
            ...prev,
            totalsales: item.nos,
          }));
        }

      });
    } else {
      console.log("Header stat count length else ");
    }
  }, [orderStatusCount]);

  useEffect(() => {

    getHeaderData();

  }, []);

  const defaultLabelStyle = {
    fontSize: '5px',
    fontFamily: 'sans-serif',
    color: "#ffffff"
  };

  return (
    <div>
      <div className="Homepage-main-container">
        <div className="HomePage-left-container">

          <div className="Header-statistics-container ps-2 pe-2">

            <div className="Homepage-label-andimage-outer-container card-firstcolor">
              <div className="d-flex">
                <div className="Homepage-statistics-card-image-container"><img src={ic_total_files} /></div>
                <div className="card Homepage-statistics-card-image-container-parent card-firstcolor">

                  {
                    isCallingHeaderApi ?

                      <>
                        <label>Total</label><span>

                          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>

                        </span>
                      </>


                      :
                      <>
                        <label>Total</label><span>{orderStatusCountObject.sum}</span>
                      </>
                  }


                </div>
              </div>
            </div>

            <div className="Homepage-label-andimage-outer-container card-secondcolor">
              <div className="d-flex">
                <div className="Homepage-statistics-card-image-container"><img src={ic_waiting_for_approval} /></div>
                <div className="card Homepage-statistics-card-image-container-parent card-secondcolor">

                  

                  {
                    isCallingHeaderApi ?

                      <>
                        <label>Waiting For Accept</label><span>

                          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>

                        </span>
                      </>


                      :
                      <>
                        <label>Waiting For Accept</label><span>{orderStatusCountObject.waiting_for_accept}</span>
                      </>
                  }

                </div>
              </div>
            </div>

            <div className="Homepage-label-andimage-outer-container card-thirdcolor">

              <div className="d-flex">
                <div className="Homepage-statistics-card-image-container"><img src={ic_quotation_generated} /></div>
                <div className="card Homepage-statistics-card-image-container-parent card-thirdcolor">
                  

                  {
                    isCallingHeaderApi ?

                      <>
                        <label>Quotation Generated</label><span>

                          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>

                        </span>
                      </>


                      :
                      <>
                        <label>Quotation Generated</label><span>{orderStatusCountObject.quotation_generated}</span>
                      </>
                  }

                </div>
              </div>

              <div className="Homepage-child-totalamount-of-proposals">
                <label>Total : {orderStatusCountObject.ttlamtofpropsl}</label>
                
              </div>
            </div>

            <div className="Homepage-label-andimage-outer-container card-fourthcolor">
              <div className="d-flex">
                <div className="Homepage-statistics-card-image-container"><img src={ic_order_confirmed} /></div>
                <div className="card Homepage-statistics-card-image-container-parent card-fourthcolor">
                  

                  {
                    isCallingHeaderApi ?

                      <>
                        <label>Order Confirmed</label><span>

                          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>

                        </span>
                      </>


                      :
                      <>
                        <label>Order Confirmed</label><span>{orderStatusCountObject.order_confirmed}</span>
                      </>
                  }

                </div>
              </div>
              <div className="Homepage-child-totalamount-of-proposals">
                <label>Total : {orderStatusCountObject.totalsales}</label>
              </div>
            </div>

          </div>


          <div className="HomePage-left-container-content">
            <h4><img className="ic_previous_request me-2" src={ic_history} />Previous Requests</h4>

            <EnquiryListTable />
          </div>
        </div>

        <div className="HomePage-right-container">
          <div className="HomePage-important-notifications-container">
            <div className="Homepage-important-notifications-container-header">
              <img
                src={ic_important_notifications}
                alt="important notifications"
              />{" "}
              Important Notifications
            </div>
            <div className="HomePage-ulContainer">
              <ul>
                {importantNotifications.length > 0 ? (
                  importantNotifications.map((item, index) => {
                    return <li key={index}>{item.message}</li>;
                  })
                ) : (
                  <li className="no_notification_list_item">
                    <div>
                      <img src={ic_no_notification} />
                      <span>
                        Nothing yet
                      </span>
                    </div>
                  </li>
                )}
              </ul>
            </div>
          </div>

          <div className="HomePage-offers-container">
            <div className="Homepage-important-notifications-container-header">
              <img src={ic_offers} alt="offers" />
              Offers For You
            </div>
            <div className="HomePage-ulContainer">
              <ul>
                {offers.length > 0 ? (
                  offers.map((item, index) => {
                    return (
                      <li key={index}>
                        <div >
                          <span>{item.message}</span>
                        </div>
                      </li>
                    );
                  })
                ) : (
                  <li className="no_offer_list_item">

                    <div>
                      <img src={ic_no_offer} />
                      <span>
                        No offers available.
                      </span>
                    </div>

                  </li>
                )}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Homepage;
